import React from "react"
import Img from "../../assets/Album.png"
import "./styles.css"
import { useState } from "react"
import { ConfirmationModal } from "../../components/ConfirmationModal"

function Info(props) {
  const { spotifyLink, youtubeLink, buyLink } = props
  const [displayOverlay, setDisplayOverlay] = useState(false)
  const [displayModal, setDisplayModal] = useState(false)
  const [displayConfirmationYoutube, setDisplayConfirmationYoutube] =
    useState(false)
  const [displayConfirmationSpotify, setDisplayConfirmationSpotify] =
    useState(false)

  function mudarEstadosSpotify() {
    if (spotifyLink) {
      setDisplayConfirmationSpotify(true)
      setDisplayOverlay(true)
      setDisplayModal(true)
    }
  }

  function mudarEstadosYoutube() {
    if (youtubeLink) {
      setDisplayConfirmationYoutube(true)
      setDisplayOverlay(true)
      setDisplayModal(true)
    }
  }

  function mudarEstadosOverlay() {
    setDisplayModal(!displayModal)
    setDisplayOverlay(!displayOverlay)
  }

  return (
    <div className="white-box-content">
      <div className="content">
        <div className="start">
          <div className="imagem-container-discos">
            <img
              src={"data:image/jpeg;base64," + props.image_link}
              width="95"
              id="base64image"
            />
          </div>
          <div className="texto">
            <div className="titulos">
              <p>
                <b> {props.name} </b>
              </p>
              <div className="autor-mobile">{props.author_name}</div>
            </div>
          </div>
          <div className="middle">
            <div className="barraVertical" />
          </div>
        </div>
        <div className="end">
          <div className="autor-desktop">{props.author_name}</div>
          <div className="icones">
            <div className="ondeOuvir">Onde ouvir:</div>
            <div
              className="iconeIndividual"
              onClick={() => mudarEstadosSpotify()}
            >
              <img
                src={
                  props.spotifyLink
                    ? "https://cdn-icons-png.flaticon.com/512/174/174872.png"
                    : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5JoK5qdeq5Y2KecdAAke4WgDuY3QvbzFDFoq3cCyDFBoijEE2po34xZaEIO9kimofz18&usqp=CAU"
                }
                width={25}
                height={25}
                alt="Minha Figura"
              />
              <br />
              Spotify
            </div>
            <div
              className="iconeIndividual"
              onClick={() => mudarEstadosYoutube()}
            >
              <img
                src={
                  props.youtubeLink
                    ? "https://cdn-icons-png.flaticon.com/512/1384/1384060.png"
                    : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRaD8emGd1SBKf4lKAPvyUCsnWKhhB-6ddOZg&usqp=CAU"
                }
                width={25}
                height={25}
                alt="Minha Figura"
              />
              <br />
              YouTube
            </div>
          </div>
        </div>
      </div>

      {displayModal
        ? displayConfirmationSpotify && (
            <ConfirmationModal
              buyLink={spotifyLink}
              setDisplayModal={setDisplayModal}
              displayModal={displayModal}
            />
          )
        : null}

      {displayModal
        ? displayConfirmationYoutube && (
            <ConfirmationModal
              buyLink={youtubeLink}
              setDisplayModal={setDisplayModal}
              displayModal={displayModal}
            />
          )
        : null}

      {displayModal ? (
        <div
          className={`Overlay2 ${displayOverlay ? "Show" : ""}`}
          onClick={() => mudarEstadosOverlay()}
        />
      ) : null}
    </div>
  )
}
export default Info
